export default __webpack_public_path__ + "001da71769e1bf3a15a19a32ebd5d966.png";